import { InfoTip } from "@/components/InfoTip";
import type { SortKey } from "@/hooks/useListParams";

interface Props {
  value: SortKey;
  onChange: (next: SortKey) => void;
  showTenant?: boolean;
}

export function SortSelect({ value, onChange, showTenant }: Props): JSX.Element {
  return (
    <label className="text-xs text-ink-300 inline-flex items-center gap-2">
      Sort
      <InfoTip
        label="Sort order"
        body="Order the list by Name, PWS ID, Tenant (the owning utility), or Alerts — most urgent first (High, then Medium, then Low)."
      />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as SortKey)}
        className="bg-ink-900 ring-1 ring-ink-600 rounded px-2 py-1 text-sm text-ink-100 focus:outline-none focus:ring-2 focus:ring-ink-400"
      >
        <option value="name">Name</option>
        <option value="pws_id">PWS ID</option>
        {showTenant && <option value="tenant">Tenant</option>}
        <option value="alerts">Alerts</option>
      </select>
    </label>
  );
}
